export default __webpack_public_path__ + "static/media/home5.7b1d5f04.jpg";